import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../CommonComponents/OPL/Modal/ModalFooter';
import { theme } from '../theme/theme';
import { Button } from '../CommonComponents/OPL/Button/Button';
import { ModalCloseButton } from '../CommonComponents/OPL/Modal/ModalCloseButton';

const container = document.createElement('div');

interface Props {
  resolve(value: boolean): void;
}

const ConfirmationDialog: React.FC<Props> = ({ resolve }) => {
  const [isOpen, setIsOpen] = useState(true);

  const unmount = () => {
    // Unmount the portal first before unmounting the entire component
    // to prevent the false "different copy of react" warning
    // https://github.com/facebook/react/issues/22343
    setIsOpen(false);

    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(container);
    }, 0);
  };

  const onClose = () => {
    resolve(false);
    unmount();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Modal isOpen onRequestClose={onClose}>
        <ModalHeader variant="warning">Warning</ModalHeader>
        <ModalCloseButton onClick={onClose} />

        <ModalBody>
          You have unsaved changes on this page. Are you sure you want to leave?
        </ModalBody>

        <ModalFooter>
          <Button variant="subtleInactive" onClick={onClose}>
            Cancel
          </Button>

          <Button
            variant="error"
            onClick={() => {
              ADV.util.Router.unregisterNavigateAwayCallback();
              resolve(true);
              unmount();
            }}
            ml="12"
          >
            Leave This Page
          </Button>
        </ModalFooter>
      </Modal>
    </ThemeProvider>
  );
};

export const showOPLConfirmationDialog = () => {
  return new Promise<boolean>(resolve => {
    ReactDOM.render(<ConfirmationDialog resolve={resolve} />, container);
  });
};
